var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3748 24.5404C19.3748 25.5681 18.9665 26.5537 18.2398 27.2804C17.5131 28.0071 16.5275 28.4154 15.4998 28.4154C14.4721 28.4154 13.4865 28.0071 12.7598 27.2804C12.0331 26.5537 11.6248 25.5681 11.6248 24.5404M16.4311 6.46093L14.5375 6.45705C10.2182 6.44672 6.46847 9.95618 6.43877 14.2071V19.1025C6.43877 20.1229 6.3096 21.1188 5.75289 21.9674L5.38218 22.5331C4.81772 23.3908 5.42481 24.5404 6.43877 24.5404H24.5608C25.5748 24.5404 26.1806 23.3908 25.6174 22.5331L25.2467 21.9674C24.6913 21.1188 24.5608 20.1216 24.5608 19.1012V14.2083C24.5092 9.95618 20.7504 6.47126 16.4311 6.46093Z",
    stroke: "#005342",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4993 2.58203C16.1845 2.58203 16.8416 2.8542 17.326 3.33867C17.8105 3.82314 18.0827 4.48022 18.0827 5.16536V6.45703H12.916V5.16536C12.916 4.48022 13.1882 3.82314 13.6727 3.33867C14.1571 2.8542 14.8142 2.58203 15.4993 2.58203Z",
    stroke: "#005342",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.1147e731ef20435dab1a0260522a8347.svg";
export { ForwardRef as ReactComponent };